import React from "react";

import { useAppSelector } from "../../../app/store";
import {
  getStakeholderById,
  getEnrichedStakeholderById,
} from "../logic/stakeholderSlice";
import ConstitutionPill from "./ConstitutionPill";



interface StakeholderHeaderProps {
  stakeholderId: string;
}

const StakeholderHeader: React.FC<StakeholderHeaderProps> = ({
  stakeholderId,
}) => {
  const stakeholder = useAppSelector((state) =>
    getStakeholderById(state, stakeholderId),
  );

  const enrichedStakeholder = useAppSelector((state) =>
    getEnrichedStakeholderById(state, stakeholderId),
  );

  if (!stakeholder) {
    return null;
  }

  const constitution = enrichedStakeholder?.customer_details?.constitution;

  const cifNumber = enrichedStakeholder?.customer_details?.cif_number;

  return (
    <div className="flex items-center justify-between px-4">
      <div className="flex min-w-0 flex-col gap-1">
        <span className="truncate font-sans text-[14px] font-medium leading-5 text-[#0A0A0A]">
          {stakeholder.name || "Name unavailable"}
        </span>

        <span className="font-sans text-[12px] font-normal leading-4 text-[#737373]">
          {cifNumber || "--"}
        </span>
      </div>

      <ConstitutionPill value={constitution} />
    </div>
  );
};

export default StakeholderHeader;